import {
  FAQS,
  NAV_MENU,
  FooterLinks,
  NavSubmenuLinks,
  AnalyticsHeader,
  TERMS_AND_CONDITION,
  PASS_PURCHASE_SUCCESS_MESSAGE,
  TERMS_AND_CONDITION_OPT_OUT_RESTRICTED,
} from "./helper";
import { routes } from "src/shared/routes";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

import DESKTOP_BANNER_URL from "public/images/sacramentorivercats/2025_CATS PASS_WEB BANNER_1920x450.jpg";
import MOBILE_BANNER_URL from "public/images/sacramentorivercats/2025_CATS PASS_MOBILE HEADER_375x550.jpg";

export const sacramentorivercats_pass: TTeamConfig = {
  TEAM_SCHEMA: "sacramentorivercats_pass",
  TEAM_FULL_NAME: "Sacramento River Cats",
  BROWSER_TITLE: "Summer Pass",
  CLIENT_ID: "718647ae2caa.seasonshare.rivercats-rivercats.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#000000",
    COLORS_SECONDARY: "#ccb47b",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    IS_BALLPARK_APP: true,
    IS_INTERCOM_ENABLED: true,

    ANALYTICS_HEADER: AnalyticsHeader,

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: false,
      ADDITIONAL_SUB_MENU_ITEMS: NavSubmenuLinks,
    },

    ACCOUNT_MANAGER_URL: "https://am.ticketmaster.com/rivercats/",

    FOOTER: {
      LINKS: FooterLinks,
    },
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      HIDE_PASS_DETAILS: true,
    },

    PASS: {
      SHOW_FAQ_BUTTON: true,
      ADD_SERVICE_FEE_TO_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Buy Now!",
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT_OPT_OUT_RESTRICTED: "Buy Now!",
    },

    SHOW_ALL_PASSES_UNDER_BANNER: true,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
      ATTEND_BUTTON_COLOR: "#ccb47b",
    },

    ADD_ON: {
      ADD_SERVICE_FEE_TO_PRICE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
      NO_UPCOMING_RENEWAL_PERIOD_MESSAGE:
        "For those subscription pass holders, you will be able to view & manage your subscription after July 23, 2025",
    },
  },

  IMAGES: {
    LANDING_PAGE_STATIC_BANNER_URL: DESKTOP_BANNER_URL.src,
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL: MOBILE_BANNER_URL.src,
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/Sacramento%20River%20Cats/Full%20Stadium%20Exhib%20Game%202025.png",
    GROUP_INVITE_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/Sacramento%20River%20Cats/Full%20Stadium%20Exhib%20Game%202025.png",
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/Sacramento-River%20Cats_1.png",
  },

  LANGUAGES: {
    FAQS,
    NAV_MENU,
    TERMS_AND_CONDITION,
    PRE_PURCHASE_FAQS: FAQS,
    PASS_PURCHASE_SUCCESS_MESSAGE,
    TERMS_AND_CONDITION_OPT_OUT_RESTRICTED,
    TERMS_AND_CONDITION_ADD_ON: TERMS_AND_CONDITION,
  },
};
